module.exports = __webpack_public_path__ + "public/images/all-things-drawing.5eac27d70583282ffeca54a971777aaf.jpg";